import { useQuery } from '@tanstack/react-query';

import { API_CACHE_KEYS } from '@/features/api/constants/cache';
import { useGrapevineCommentApi } from '@/features/api/hooks/grapevine-comment/useGrapevineCommentApi';
import { isEmptyOrNull } from '@/shared/utils/string';

export const useGetComment = (commentId: string | undefined = '') => {
  const api = useGrapevineCommentApi();
  return useQuery({
    queryKey: [API_CACHE_KEYS.COMMENT, commentId],
    queryFn: () => api.readSingleComment({ commentId }),
    enabled: !isEmptyOrNull(commentId)
  });
};
